// extracted by mini-css-extract-plugin
export default {"container":"fi97TLHtlTYJPECAPkRs","tabs":"hZl8uRsG9Ui06fzj7rTH","tab":"AgAPtoVZbeSKqa0_9_K2","content":"SS5fEk0C3m1TA1CnSNe2"};